module.exports = __webpack_public_path__ + "images/marketing_site/blog_headshot/jody_ferry.jpg";